import { render, staticRenderFns } from "./ListagemAdesoesInternaCollapses.vue?vue&type=template&id=2fa5f22b&scoped=true"
import script from "./ListagemAdesoesInternaCollapses.vue?vue&type=script&lang=js"
export * from "./ListagemAdesoesInternaCollapses.vue?vue&type=script&lang=js"
import style0 from "./ListagemAdesoesInternaCollapses.vue?vue&type=style&index=0&id=2fa5f22b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5f22b",
  null
  
)

export default component.exports